import React from "react";
import placeholder from "../../assets/placeholder.svg";

// Image element with a default placeholder
export default function Image(props) {
  return (
    <img {...props} src={props.src || placeholder} alt={props.alt || ""} />
  );
}
